// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetRbacMeDemoRbacMeGetQueryResponse } from "../models/demoController/GetRbacMeDemoRbacMeGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import { getRbacMeDemoRbacMeGet } from "../client/getRbacMeDemoRbacMeGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getRbacMeDemoRbacMeGetQueryKey = () => [{ url: '/demo/rbac/me' }] as const

export type GetRbacMeDemoRbacMeGetQueryKey = ReturnType<typeof getRbacMeDemoRbacMeGetQueryKey>

export function getRbacMeDemoRbacMeGetQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getRbacMeDemoRbacMeGetQueryKey()
        return queryOptions<GetRbacMeDemoRbacMeGetQueryResponse, ResponseErrorConfig<Error>, GetRbacMeDemoRbacMeGetQueryResponse, typeof queryKey>({
        
        queryKey,
        queryFn: async ({ signal }) => {
            return getRbacMeDemoRbacMeGet({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Get your current role and permissions for RBAC demo.
 * @summary Get Rbac Me
 * {@link /demo/rbac/me}
 */
export function useGetRbacMeDemoRbacMeGet<TData = GetRbacMeDemoRbacMeGetQueryResponse, TQueryData = GetRbacMeDemoRbacMeGetQueryResponse, TQueryKey extends QueryKey = GetRbacMeDemoRbacMeGetQueryKey>(options: 
{
  query?: Partial<UseQueryOptions<GetRbacMeDemoRbacMeGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = (resolvedOptions && 'queryKey' in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? getRbacMeDemoRbacMeGetQueryKey()

         const query = useQuery({
          ...getRbacMeDemoRbacMeGetQueryOptions(config),
          ...resolvedOptions,
          queryKey
         } as unknown as UseQueryOptions<GetRbacMeDemoRbacMeGetQueryResponse, ResponseErrorConfig<Error>, TData, GetRbacMeDemoRbacMeGetQueryResponse, TQueryKey>, toValue(queryClient)) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}